import { CustomerZoneGetResponseType } from "@sellar-io/api-v2/types";
import { useQuery } from "@tanstack/react-query";
import { useFirebaseUser } from "../../../useFirebaseUser.shared";
import { useSellarCurrentBusiness } from "../../../useSellarCurrentBusiness.shared";
import {
  apiV2AssertResponse,
  ApiV2QueryOptions,
  apiV2Request,
  getDefaultQueryOptionsV2,
} from "../apiV2Request";
import { ServerStateKeys } from "../ServerStateKeys";

export const useCustomerZone = <TData = CustomerZoneGetResponseType,>(
  customerZoneId: number,
  options?: ApiV2QueryOptions<TData>,
) => {
  const { business } = useSellarCurrentBusiness();
  const { user } = useFirebaseUser();

  return useQuery({
    queryKey: [
      user?.uid,
      business?.id,
      ServerStateKeys.CustomerZones,
      customerZoneId,
    ],

    queryFn: () =>
      apiV2Request({
        user,
        business,
        method: "get",
        path: `customer-zones/${customerZoneId}`,
      }).then((data) => apiV2AssertResponse<TData>(data).data),
    ...getDefaultQueryOptionsV2({
      context: { scope: "business", user, business: business },
      options: options,
    }),
  });
};
